import React from 'react'
import useStyles from './style'
import { Button, Grid, Typography } from '@mui/material'
import { API_ENDPOINTS } from 'constants'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'

const AboutUs = (props) => {
  const { aboutProcess } = props
  const classes = useStyles()
  const navigate = useNavigate()

  const leftCard = {
    offscreen: {
      x: -1600,
    },
    onscreen: {
      x: 0,
      transition: {
        type: 'just',
        bounce: 0.4,
        duration: 0.9,
      },
    },
  }
  const rightCard = {
    offscreen: {
      x: 1600,
    },
    onscreen: {
      x: 0,
      transition: {
        type: 'just',
        bounce: 0.4,
        duration: 0.9,
      },
    },
  }

  return (
    <>
      {aboutProcess &&
        aboutProcess?.map((data) => (
          <Grid container className={classes.root} key={data?._id}>
            <motion.div
              className="container"
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true, amount: 0.5 }}
            >
              <Grid item xs={12} className={classes.wrapper}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={7}
                  className={classes.imgContainer}
                >
                  <motion.div
                    style={{ height: '100%', width: '100%' }}
                    variants={leftCard}
                  >
                    <img
                      src={API_ENDPOINTS?.FILE_URL + data?.image}
                      alt={data?.title}
                      className={classes.img}
                    />
                    <div className={classes.experienceBox}>
                      <Typography variant="h5" style={{ paddingBlockEnd: 8 }}>
                        {' '}
                        <strong>{data?.foundation} +</strong>{' '}
                      </Typography>{' '}
                      <Typography variant="body1">
                        YEARS <br /> EXPERIENCE
                      </Typography>
                    </div>
                  </motion.div>
                </Grid>
                <Grid item xs={12} sm={6} md={5} className={classes.content}>
                  <motion.div
                    style={{ height: '100%', width: '100%' }}
                    variants={rightCard}
                  >
                    <div className={classes.title}>
                      <Typography variant="h3">{data?.title}</Typography>
                    </div>
                    <div className={classes.description}>
                      <Typography variant="body1">{data?.content}</Typography>
                    </div>
                    <div className={classes.btn}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate('/about')}
                      >
                        Know more
                      </Button>
                    </div>
                  </motion.div>
                </Grid>
              </Grid>
            </motion.div>
          </Grid>
        ))}
    </>
  )
}

export default AboutUs
